export default function workMotivesDataFormatter(data) {
  const calc = data?.calculation_container || {};

  function scale(value) {
    return Math.trunc(Number(value || 0) * 100);
  }

  return [
    scale(calc.realistic_motive),
    scale(calc.investigative_motive),
    scale(calc.artistic_motive),
    scale(calc.social_motive),
    scale(calc.enterprising_motive),
    scale(calc.conventional_motive),
  ];
}
